import { $, _ } from 'wgnet-awesomejs';
import BaseInput from 'source/lib/component/input/base';
import template from './template.html';

const CSS_MOBILE_WIDTH_MEDIA_QUERY = 800;

const EulaInput = BaseInput.extend({
    name: 'eula-input',
    template,

    initialize(options = {}) {
        BaseInput.prototype.initialize.call(this, Object.assign(
            options,
            {
                explisitConsentsEnabled: options.explisitConsentsEnabled === 'true',
                lesta: options.lesta === 'true',
            },
        ));
        const checked = this.data['input-checked'] === 'true';

        this.$checkbox = this.$('.js-input');
        this.$eulaLabel = this.$('.js-eula-field > label');
        this.errorClass = options['wrapper-error-class'];

        this.$checkbox.prop('checked', checked);

        this.bindParent();
    },
    events: {
        'change .js-eula-field > input': 'removeErrorStyle',
        'click .js-eula-tooltip-ico': 'openTooltip',
        'click .js-eula-tooltip-close': 'closeTooltip',
        'mouseover label': 'hover',
        'mouseout label': 'blur',
    },
    hover({ target }) {
        const $target = $(target);
        if ($target.hasClass('js-prevent-hover')) {
            return;
        }
        $target.parents('.js-input-wrapper').find('.js-input').addClass('checkbox-airy__hover');
    },
    blur() {
        this.$('.js-input').removeClass('checkbox-airy__hover');
    },
    closeTooltip(event) {
        this.toogleTooltip(event.target.parent);
    },
    openTooltip(event) {
        event.preventDefault();
        if (window.innerWidth <= CSS_MOBILE_WIDTH_MEDIA_QUERY) {
            this.toogleTooltip(event.target, true);
            $('body').one('click', () => this.closeTooltip(event));
            $(window).one('resize', () => this.closeTooltip(event));
        }
        return false;
    },
    setFocus() {},
    lostFocus() {},
    toogleTooltip(tooltip, state = false) {
        const $infoEl = $('.js-eula-tooltip-info', tooltip);
        let left;
        if (state) {
            left = -$(tooltip).offset().left;
        }
        $infoEl.css({
            display: state ? 'block' : '',
            left: state ? left : '',
        });
    },
    bindParent(...args) {
        BaseInput.prototype.bindParent.apply(this, args);

        this.$root.on('component:all:eula-checkbox-validated', _.bind(this.onValidated, this));
    },
    onValidated(event, data) {
        const errors = data.result.__all__;
        if (errors) {
            this.setErrorStyle();
        } else {
            this.removeErrorStyle();
        }
    },
    setErrorStyle() {
        this.$eulaLabel.addClass(this.errorClass);
    },
    removeErrorStyle() {
        this.$eulaLabel.removeClass(this.errorClass);
    },
});

export default EulaInput;
